import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoof = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "#000",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", { d: "m22.5 12h-13.5l-3.75-7.5" }), /* @__PURE__ */ _jsxs("g", {
			strokeLinecap: "square",
			strokeOpacity: .87,
			children: [/* @__PURE__ */ _jsx("path", { d: "m9 12v6" }), /* @__PURE__ */ _jsx("path", { d: "m22.5 12v5.25c0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197h-19.5c-.19891 0-.38968-.079-.53033-.2197-.14065-.1406-.21967-.3314-.21967-.5303v-5.25l3.75-7.5h13.5z" })]
		})]
	})
});
export default SvgRoof;
